var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-dialog",
    { ref: "base", attrs: { "max-width": "300px" } },
    [
      _c(
        "v-card",
        { attrs: { "min-height": "80vh" } },
        [
          _c("v-card-title", [_vm._v("Подписка на сайт")]),
          _c("v-card-subtitle", {
            domProps: { innerHTML: _vm._s(_vm.subtitle) },
          }),
          _c(
            "v-card-text",
            [
              _c("div", [_vm._v(_vm._s(_vm.text))]),
              _c("br"),
              _c(
                "v-container",
                { attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    { attrs: { align: "center" } },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "text-left px-0",
                          staticStyle: { "max-width": "50px" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticStyle: { "font-size": "20px" },
                              attrs: { small: "", elevation: "1", fab: "" },
                              on: {
                                click: function ($event) {
                                  _vm.count === 1 ? undefined : (_vm.count -= 1)
                                },
                              },
                            },
                            [_vm._v("- ")]
                          ),
                        ],
                        1
                      ),
                      _c("v-col", { staticClass: "text-center px-0" }, [
                        _c("h1", [_vm._v(_vm._s(_vm.count) + " мес.")]),
                      ]),
                      _c(
                        "v-col",
                        {
                          staticClass: "text-right px-0",
                          staticStyle: { "max-width": "50px" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticStyle: { "font-size": "20px" },
                              attrs: { small: "", elevation: "1", fab: "" },
                              on: {
                                click: function ($event) {
                                  _vm.count += 1
                                },
                              },
                            },
                            [_vm._v("+")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("h1", { staticClass: "text-center" }, [
                _vm._v("Итого " + _vm._s(_vm.count * _vm.SHOP_PRICE) + "₽"),
              ]),
              _c("br"),
              _c(
                "div",
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      attrs: { "lazy-validation": "" },
                      model: {
                        value: _vm.valid,
                        callback: function ($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid",
                      },
                    },
                    [
                      _c("v-text-field", {
                        ref: "email",
                        attrs: {
                          outlined: "",
                          dense: "",
                          label: "Электронная почта",
                          "error-messages": _vm.error_message,
                        },
                        on: {
                          input: function ($event) {
                            _vm.error_message = ""
                          },
                        },
                        model: {
                          value: _vm.customerEmail,
                          callback: function ($$v) {
                            _vm.customerEmail =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "customerEmail",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn",
                      attrs: {
                        loading: _vm.loading,
                        color: "success",
                        block: "",
                      },
                      on: { click: _vm.startPay },
                    },
                    [_vm._v("ПРОДЛИТЬ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c(
                "v-container",
                { staticClass: "py-0", attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "pb-1 pt-2 text-right",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn btn-h",
                              attrs: { width: "108" },
                              on: {
                                click: function ($event) {
                                  return _vm.$refs.base.hide()
                                },
                              },
                            },
                            [_vm._v("Закрыть ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }